/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */
import { PropallyApiFactory } from "@/module/CustomApiFactory";

export const Logout = async () => {
  const fp = PropallyApiFactory();
  try {
    const logout = await fp.v1LogoutPost({ withCredentials: true });
    return logout.status === 200;
  } catch (e) {
    console.error(e);
    return false;
  }
};
